jQuery(function($) {

  var $wrapper = $('#ways-to-wear');

  var $videos = $wrapper.find('.vimeo-video');

  $videos.each(function() {
    var $video = $(this),
        player = new Vimeo.Player($video[0]);

    player.on('play', __onVimeoPlay);
    player.on('pause', __onVimeoPause);

    $video.data('player', player);
  });


  /**
     * Set up the carousel
     */
  var $carousel = new Swiper($wrapper[0], {
    slidesPerView: 4,
    spaceBetween: 20,
    initialSlide: 1,
    centeredSlides: false,
    speed: 400,
    // autoplayDisableOnInteraction: false,
    loop: true,
    autoplay: false,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 12
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      998: {
        slidesPerView: 4,
        spaceBetween: 65,
      }
    },
    on: {
      init: __pauseAndPlayVideos,
      slideChangeTransitionEnd: __pauseAndPlayVideos,
    }
  });


  function __pauseAndPlayVideos() {
    $videos.each(function() {
      var $video = $(this);

      if (!$video.is('#ways-to-wear .swiper-slide-active .vimeo-video')) {
        $video.data('player').pause();
      } else {
        $video.data('player').play();
      }
    });
  }

  function __onVimeoPlay() {
    console && console.log('vimeo video playing');
  }

  function __onVimeoPause() {
    console && console.log('vimeo video playing');
  }

});

/* Light gallery product click to zoom for Kichana products only */
// $(document).ready(function() {
//   if ($(window).width() > 767) {    
//     $(".main-product-carousel .swiper-wrapper").lightGallery({
//       speed: 500,
//       selector: '.lightgallery-slide',
//       showZoomInOutIcons:!0,
//       actualSize:!1,
//       plugins:[lgZoom]
//     });
//   }
// });
if ($(window).width() > 767) { 
  $(document).ready(function(){
    lightGallery(document.getElementById("section-product-kichanatemplate"),{
      selector:".lightgallery-slide ",
      showZoomInOutIcons:!0,
      actualSize:!1,
      plugins:[lgZoom]
    });
  });
};